import React from 'react'
import { Link } from 'react-router-dom'
import {
	CCard,
	CCardBody,
	CCardGroup,
	CCol,
	CContainer,
	CForm,
	CFormInput,
	CInputGroup,
	CInputGroupText,
	CRow,
} from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { cilLockLocked, cilUser } from '@coreui/icons'
import ServerConnector from 'src/ServerConnector'
import AppButton from 'src/components/AppButton'

export default class Login extends React.Component {

	constructor(props) {
		super(props)

		localStorage.setItem("user_id", "");
		localStorage.setItem("password", "");

		this.state = {
			pageError: "",
			loginButtonLoading: false,
			inputs: {
				username: "",
				usernameerr: "",
				password: "",
				passworderr: ""
			}
		}
	}

	updateInput(inputName, event) {

		let inputs = this.state.inputs;
		inputs[inputName] = event.target.value;
		inputs[inputName + "err"] = "";
		this.setState({
			inputs: inputs
		});
	}

	submitForm() {

		if (this.isValidForm()) {

			this.setState({
				loginButtonLoading: true
			});

			let inputs = this.state.inputs;
			let connector = new ServerConnector();
			let dataMap = {
				"_action_code": "APP_LOGIN",
				"password": inputs.password,
				"user_id": inputs.username
			};
			connector.postData(dataMap, (data) => { // success

				this.setState({
					loginButtonLoading: false
				});
				localStorage.setItem("user_id", inputs.username);
				localStorage.setItem("password", inputs.password);
				localStorage.setItem("template_path", data.data.template_path);
				this.props.history.push("/admin");

			}, (err_cd, msg, data) => { // failure

				this.setState({
					pageError: msg,
					loginButtonLoading: false
				});
			})
		}
	}

	isValidForm() {

		var isValid = true;
		let inputs = this.state.inputs;

		if (inputs.username.length == 0) {
			inputs["usernameerr"] = "Required";
			isValid = false;
		}

		if (inputs.password.length == 0) {
			inputs["passworderr"] = "Required";
			isValid = false;
		}

		if (!isValid) {
			this.setState({ inputs: inputs });
		}

		return isValid;
	}

	enterKeyPressed(event) {
		var code = event.keyCode || event.which;
		if(code === 13) {
			this.submitForm();
		} 
	}

	render() {
		return (
			<div className="bg-light min-vh-100 d-flex flex-row align-items-center">
				<CContainer>
					<CRow className="justify-content-center">
						<CCol md={5}>
							<CCardGroup>
								<CCard className="p-4">
									<CCardBody>
										<CForm>
											<h2>Doubt Clearing App</h2>
											<p className="text-medium-emphasis"> Admin Login</p>
											<div className="inputError">{this.state.pageError}</div>
											<CInputGroup>
												<CInputGroupText>
													<CIcon icon={cilUser} />
												</CInputGroupText>
												<CFormInput
													type="text"
													placeholder="Username"
													value={this.state.inputs.username}
													onChange={(event) => this.updateInput("username", event)}
													onKeyPress={(event) => this.enterKeyPressed(event)} />
											</CInputGroup>
											<div className="inputError">{this.state.inputs.usernameerr}</div>
											<CInputGroup className="mt-3">
												<CInputGroupText>
													<CIcon icon={cilLockLocked} />
												</CInputGroupText>
												<CFormInput
													type="password"
													placeholder="Password"
													value={this.state.inputs.password}
													onChange={(event) => this.updateInput("password", event)}
													onKeyPress={(event) => this.enterKeyPressed(event)} />
											</CInputGroup>
											<div className="inputError">{this.state.inputs.passworderr}</div>
											<CRow className="mt-4">
												{/* <CCol xs={6}>
													<Link to="/">
														Forgot Password?
													</Link>
												</CCol> */}
												<CCol xs={12} className="alignRight">
													<AppButton
														color="primary"
														name="Login"
														size="sm"
														isLoading={this.state.loginButtonLoading}
														onClick={() => this.submitForm()} />
												</CCol>
											</CRow>
										</CForm>
									</CCardBody>
								</CCard>
							</CCardGroup>
						</CCol>
					</CRow>
				</CContainer>
			</div>
		)
	}
}
